(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["abdeen-branch-phone"] && !Shopify.designMode) return;
  try {
    (() => {
  if (!location.pathname.endsWith('/pages/landing-page')) return;
  const mapLink = document.querySelector('.ab-branch a[href="https://www.google.com/maps?cid=3230727330498903594"]');
  const branch = mapLink && mapLink.closest('.ab-branch');
  if (!branch) return;
  const update = () => {
    branch.querySelectorAll('a[href^="tel:"]').forEach(link => {
      if (link.getAttribute('href') !== 'tel:+962792626669') link.setAttribute('href', 'tel:+962792626669');
    });
    branch.querySelectorAll('[data-copy]').forEach(button => {
      if (button.dataset.copy !== '+962792626669') button.dataset.copy = '+962792626669';
    });
    branch.querySelectorAll('.ab-meta .ab-chip').forEach(chip => {
      [...chip.childNodes].forEach(node => {
        if (node.nodeType !== Node.TEXT_NODE) return;
        const corrected = node.textContent.replace(/\(06\)\s*420\s*7420|064207420/g, '0792626669');
        if (corrected !== node.textContent) node.textContent = corrected;
      });
    });
  };
  branch.querySelectorAll('[data-copy]').forEach(button => {
    button.addEventListener('click', async event => {
      event.stopImmediatePropagation();
      const status = document.getElementById('abdeen-branch-copy-status');
      try {
        await navigator.clipboard.writeText('+962792626669');
        status.textContent = status.dataset.success;
      } catch {
        status.textContent = status.dataset.failure;
      }
    }, true);
  });
  update();
  new MutationObserver(update).observe(branch, { childList: true, subtree: true, characterData: true });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["abdeen-chat-language"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.getElementById('abdeen-chat-language');
  if (!config) return;
  const language = document.documentElement.lang.split('-')[0];
  if (!['ar', 'en'].includes(language)) return;
  const labels = JSON.parse(config.textContent);
  const translations = new Map([
    ['دردش معنا', labels.label],
    ['مرحبا', labels.title],
    ['مرحبا بالضيف', labels.welcome],
    ['نرد عادة في غضون دقائق', labels.response],
    ['عابدين هوم سنتر', labels.brand],
    ['أهلا و سهلا بك, كيف ممكن نساعدك؟ :)', labels.greeting]
  ]);
  const localize = widget => {
    widget.setAttribute('dir', language === 'ar' ? 'rtl' : 'ltr');
    const selectors = '#pushdaddy-button-label,.pushdaddy-title,.pushdaddy-description,.pushdaddy-note,.pushdaddy-avatar span,.pushdaddy-chat';
    widget.querySelectorAll(selectors).forEach(element => {
      [...element.childNodes].forEach(node => {
        if (node.nodeType !== Node.TEXT_NODE) return;
        const original = node.textContent.trim();
        const translation = translations.get(original);
        if (translation && translation !== original) node.textContent = node.textContent.replace(original, translation);
      });
    });
    const input = widget.querySelector('#pushdaddy-response-message');
    if (input && input.getAttribute('placeholder') !== labels.placeholder) input.setAttribute('placeholder', labels.placeholder);
  };
  const observed = new WeakSet();
  const attach = () => {
    const widget = document.getElementById('pushdaddy-widget');
    if (!widget || observed.has(widget)) return;
    observed.add(widget);
    localize(widget);
    new MutationObserver(() => localize(widget)).observe(widget, { childList: true, subtree: true, characterData: true });
  };
  attach();
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.id === 'pushdaddy-widget' || node.querySelector('#pushdaddy-widget'))))) attach();
  }).observe(document.body, { childList: true, subtree: true });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["abdeen-menu-accessibility"] && !Shopify.designMode) return;
  try {
    (() => {
  let nextId = 0;
  const initialize = () => {
    document.querySelectorAll('.header__menu_ul').forEach((menu) => {
      if (menu.dataset.abdeenAccessible) return;
      menu.dataset.abdeenAccessible = 'true';
      const pairs = [];
      menu.querySelectorAll('.menu__item_has_children,.header__sub--has-children').forEach((item) => {
        let control = item.querySelector(':scope > a');
        const panel = item.querySelector(':scope > .header__sub_menu,:scope > .header__mega_menu,:scope > .header__sub--children__menu');
        if (!control || !panel) return;
        const url = new URL(control.href, location.href);
        const root = window.Shopify?.routes?.root || '/';
        const isPlaceholder = control.getAttribute('href')?.startsWith('#') || (url.origin === location.origin && url.pathname.replace(/\/$/, '') === root.replace(/\/$/, ''));
        if (isPlaceholder) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = control.className;
          button.innerHTML = control.innerHTML;
          control.replaceWith(button);
          control = button;
        }
        panel.id ||= `abdeen-navigation-${++nextId}`;
        control.setAttribute('aria-controls', panel.id);
        control.setAttribute('aria-expanded', 'false');
        const pair = { item, control, panel, explicit: false };
        const setOpen = (open) => {
          item.dataset.abdeenMenuState = open ? 'open' : 'closed';
          control.setAttribute('aria-expanded', String(open));
          if (!open) pair.explicit = false;
        };
        pair.close = () => setOpen(false);
        pairs.push(pair);
        setOpen(false);
        item.addEventListener('mouseenter', () => setOpen(true));
        item.addEventListener('mouseleave', () => {
          if (!item.contains(document.activeElement)) setOpen(false);
        });
        item.addEventListener('focusout', (event) => {
          if (!item.contains(event.relatedTarget)) setOpen(false);
        });
        if (isPlaceholder) control.addEventListener('click', () => {
          const open = !pair.explicit;
          setOpen(open);
          pair.explicit = open;
        });
        control.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowDown' || (!isPlaceholder && event.key === ' ')) {
            event.preventDefault();
            setOpen(true);
            panel.querySelector('a,button')?.focus();
          }
        });
        item.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || control.getAttribute('aria-expanded') !== 'true') return;
          event.preventDefault();
          event.stopPropagation();
          pairs.filter((child) => item.contains(child.item)).forEach((child) => child.close());
          control.focus();
        });
      });
      document.addEventListener('click', (event) => {
        pairs.filter((pair) => !pair.item.contains(event.target)).forEach((pair) => pair.close());
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

})();
